import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalNext, modalBack, codeInputChanged, displayTypeChanged, startAppleTVMode } from '../../../actions/TVModeAction';
import { PrismButton } from '../../../components';

class TVModeModalFooterComponent extends Component {
  renderStep0Buttons() {
    const { timeFrameSelected, recipientSelected, modalNext } = this.props;
    if (!recipientSelected && !timeFrameSelected) {
      return (
        <div onClick={modalNext} className="footer-text">
          DISPLAY OPTIONS >
        </div>
      );
    } else if (timeFrameSelected) {
      return (
        <div onClick={modalNext} className="footer-text">
          SET A TIME FRAME >
        </div>
      );
    } else if (!timeFrameSelected && recipientSelected) {
      return (
        <div onClick={modalNext} className="footer-text">
          SET RECIPIENT(S) >
        </div>
      );
    }
  }

  renderStep1Buttons() {
    const { recipientSelected, modalNext, modalBack } = this.props;
    let back = '< BACK';
    if (recipientSelected) {
      return (
        <div style={{ marginTop: 40 }}>
          <div onClick={modalNext} className="footer-text">
            SET RECIPIENT(S) >
          </div>
          <div onClick={modalBack} className="back-button footer-text">
            {back}
          </div>
        </div>
      );
    } else {
      return (
        <div style={{ marginTop: 40 }}>
          <div onClick={modalNext} className="footer-text">
            DISPLAY OPTIONS >
          </div>
          <div onClick={modalBack} className="back-button footer-text">
            {back}
          </div>
        </div>
      );
    }
  }

  renderStep2Buttons() {
    const { modalNext, modalBack } = this.props;
    let back = "< BACK";
    return (
      <div>
        <div onClick={modalNext} className="footer-text">
          DISPLAY OPTIONS >
        </div>
        <div onClick={modalBack} className="back-button footer-text">
          {back}
        </div>
      </div>
    );
  }

  renderStep3Buttons() {
    const { modalBack } = this.props;
    let back = "< BACK";
    return (
      <div>
        {this.renderTvModeLaunch()}
        <div onClick={modalBack} className="back-button footer-text">
          {back}
        </div>
      </div>
    );
  }

  renderButtonText(){
    if (this.props.connection === 'success'){
      return ("done");
    } else if (this.props.connection === 'fail'){
      return ("try again");
    } else {
      return ("let's go");
    }
  }

  renderTvModeLaunch(){
    const { openTVMode, startAppleTVMode, displayType, codeText } = this.props;
    let onClick = openTVMode.bind(this);
    let disabled = false;

    if (displayType === 'onAppleTV') {
      onClick = startAppleTVMode.bind(this);
      disabled = codeText.length < 5;
    }

    return (
      <PrismButton
        style={{ float: "right", marginRight: 35, marginBottom: 20, marginTop: -15, width: 154 }}
        onClick= {onClick}
        disabled={disabled}
      >
        {this.renderButtonText()}
      </PrismButton>
    );
  }

  renderButtons() {
    switch (this.props.modalStep) {
      case 0:
        return this.renderStep0Buttons();
      case 1:
        return this.renderStep1Buttons();
      case 2:
        return this.renderStep2Buttons();
      case 3:
        return this.renderStep3Buttons();
    }
  }

  render() {
    return (
      <div className="modal-footer">
        {this.renderButtons()}
      </div>
    );
  }
}

const mapStateToProps = ({ tvModeStore }) => {
  const { modalStep, timeFrameSelected, recipientSelected, codeText, displayType, connection  }  = tvModeStore;
  return { modalStep, timeFrameSelected, recipientSelected, codeText, displayType, connection  };
};

const TVModeModalFooter = connect(
  mapStateToProps,
  { modalNext, modalBack, codeInputChanged, displayTypeChanged, startAppleTVMode }
)(TVModeModalFooterComponent);
export { TVModeModalFooter };


// WEBPACK FOOTER //
// ./src/screens/dashboard/TVModeModalSections/TVModeModalFooter.js